// After an update, a page that stayed open (the Windows app, a pinned tab) still runs the earlier version and asks
// for that version's page files. If one can't be loaded (Vite reports it as "vite:preloadError"), reload once to pick
// up the new version instead of showing "this screen recovered safely". At most once a minute, so a real outage
// can't loop. The server also keeps serving earlier releases' files, so this is the fallback (T19, 2026-10-23).
const KEY = '3dlabs.reloadedForUpdate';

export function reloadOnStaleBuild(win = window) {
  win.addEventListener('vite:preloadError', () => {
    let last = 0;
    try { last = Number(win.sessionStorage.getItem(KEY) || 0); } catch { /* storage blocked */ }
    if (Date.now() - last < 60_000) return; // just reloaded: let the normal error show
    try { win.sessionStorage.setItem(KEY, String(Date.now())); } catch { /* storage blocked */ }
    win.location.reload();
  });
}
